import { useState } from 'react';

const initialForm = {
  name: '',
  address: '',
  payment: '',
  size: '',
  serviceType: 'Standard clean',
  notes: '',
  isRecurring: false,
  recurringPattern: 'monthly',
  recurringEndDate: '',
};

function DayModal({ dateKey, customers, onAddCustomer, onUpdateCustomer, onDeleteCustomer }) {
  const [form, setForm] = useState(initialForm);
  const [editIndex, setEditIndex] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!form.name || !form.address) {
      return;
    }
    const customerData = { ...form, createdAt: form.createdAt || new Date().toISOString() };

    if (editIndex !== null) {
      onUpdateCustomer(editIndex, customerData);
      setEditIndex(null);
    } else {
      onAddCustomer(customerData);
    }

    setForm(initialForm);
  };

  const handleEdit = (index) => {
    const item = customers[index];
    setForm(item);
    setEditIndex(index);
  };

  const handleCancelEdit = () => {
    setForm(initialForm);
    setEditIndex(null);
  };

  return (
    <div className="day-panel">
      <div className="day-panel-header">
        <h2>Details for {dateKey}</h2>
        <p>Use this panel to track customers and cleaning appointments.</p>
      </div>

      <div className="customer-list">
        <h3>Appointments</h3>
        {customers.length === 0 ? (
          <p className="empty-state">No appointments yet. Add one below.</p>
        ) : (
          customers.map((customer, index) => (
            <div key={`${customer.name}-${index}`} className="customer-card">
              <div className="customer-card-title">
                <strong>{customer.name}</strong>
                <span>{customer.payment ? `$${customer.payment}` : 'No price'}</span>
              </div>
              <div>{customer.address}</div>
              <div>Service: {customer.serviceType || 'Standard clean'}</div>
              <div>House size: {customer.size || 'N/A'}</div>
              {customer.notes && <div className="notes">Notes: {customer.notes}</div>}
              <div className="appointment-actions">
                <button type="button" className="button-small" onClick={() => handleEdit(index)}>
                  Edit
                </button>
                <button type="button" className="button-small delete" onClick={() => onDeleteCustomer(index)}>
                  Delete
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      <form className="customer-form" onSubmit={handleSubmit}>
        <h3>{editIndex !== null ? 'Edit appointment' : 'Add appointment'}</h3>
        <label>
          Customer name
          <input name="name" value={form.name} onChange={handleChange} placeholder="Jane Doe" />
        </label>
        <label>
          Address
          <input name="address" value={form.address} onChange={handleChange} placeholder="123 Main St" />
        </label>
        <label>
          Payment
          <input name="payment" value={form.payment} onChange={handleChange} placeholder="75" />
        </label>
        <label>
          Service type
          <select name="serviceType" value={form.serviceType} onChange={handleChange}>
            <option value="Standard clean">Standard clean</option>
            <option value="Deep clean">Deep clean</option>
            <option value="Move-out clean">Move-out clean</option>
            <option value="Other">Other</option>
          </select>
        </label>
        <label>
          House size
          <input name="size" value={form.size} onChange={handleChange} placeholder="Small / Medium / Large" />
        </label>
        <label>
          Notes
          <textarea name="notes" value={form.notes} onChange={handleChange} placeholder="Special instructions" />
        </label>
        <label>
          <input 
            type="checkbox" 
            name="isRecurring" 
            checked={form.isRecurring} 
            onChange={(e) => setForm(prev => ({ ...prev, isRecurring: e.target.checked }))} 
          />
          Make this a recurring appointment
        </label>
        {form.isRecurring && (
          <>
            <label>
              Repeat pattern
              <select name="recurringPattern" value={form.recurringPattern} onChange={handleChange}>
                <option value="monthly">Every month on day {dateKey.split('-')[2]}</option>
                <option value="biweekly">Every 2 weeks</option>
                <option value="weekly">Every week</option>
              </select>
            </label>
            <label>
              End recurring (optional - leave blank for no end date)
              <input 
                type="date" 
                name="recurringEndDate" 
                value={form.recurringEndDate} 
                onChange={handleChange} 
              />
            </label>
          </>
        )}
        <div className="form-actions">
          <button type="submit">Save appointment</button>
          {editIndex !== null && (
            <button type="button" className="button-secondary" onClick={handleCancelEdit}>
              Cancel
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default DayModal;
